import React, { FC, useLayoutEffect, useRef } from 'react';
import { StickyTableHeader } from 'vh-sticky-table-header';
import './styles.css';

const TableWithStickyHeader: FC = ({ children }) => {
  const tableRef = useRef<HTMLTableElement>(null);
  const tableCloneRef = useRef<HTMLTableElement>(null);

  useLayoutEffect(() => {
    if (tableRef.current && tableCloneRef.current) {
      // Initialize the sticky header.
      const sticky = new StickyTableHeader(
        tableRef.current,
        tableCloneRef.current,
        { max: 0 },
      );
      // Make sure to destory the sticky header once the main table is unmounted.
      return () => sticky.destroy();
    }
  }, []);

  return (
    <>
      <div className="table_container table-responsive">
        <table
          ref={tableRef}
          className="table tablesorter table-striped table-hover"
        >
          {children}
        </table>
      </div>
      <div className="clone_table table_container table-responsive">
        <table
          ref={tableCloneRef}
          className="table tablesorter table-striped table-hover"
        />
      </div>
    </>
  );
};

export default TableWithStickyHeader;
